import React from 'react';
import ReactDOM from 'react-dom';
import TravelNewsUpdates from 'components/widgets/travelNewsUpdates';

const app = document.getElementById('app');
const { page } = app.dataset;

const form = document.getElementById('travelNewsUpdates');
const blog = document.getElementById('blogTravelNewsUpdates');
if(page == 'cheap-flights') {
    ReactDOM.render(<TravelNewsUpdates blogdata={blog.getAttribute('data-fulldata')}/>, form);
}
